import React, { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/motion";
import { getTestimonials } from "../lib/api";

function Stars({ rating }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className={`w-4 h-4 ${i < rating ? "text-chick fill-chick" : "text-cream/20"}`} />
      ))}
    </div>
  );
}

export default function Reviews() {
  const [data, setData] = useState({ testimonials: [], average: 0, count: 0 });

  useEffect(() => {
    getTestimonials().then(setData);
  }, []);

  return (
    <div data-testid="reviews-page" className="pb-32">
      <PageHero
        testid="reviews-hero"
        eyebrow="Straight from the feed"
        title="What Noida"
        accent="Says"
        subtitle="We let the kukkad do the talking — but our customers can't stop either."
      />

      {/* Big rating */}
      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 py-14">
        <Reveal className="flex flex-col sm:flex-row items-center gap-8 rounded-lg bg-brown-deep border border-border p-8 sm:p-12">
          <div className="text-center shrink-0">
            <p className="font-heading text-orange text-7xl sm:text-8xl leading-none" data-testid="average-rating">{data.average}</p>
            <Stars rating={Math.round(data.average)} />
            <p className="text-cream/60 text-sm mt-2">{data.count}+ happy reviews</p>
          </div>
          <div className="hidden sm:block w-px self-stretch bg-border" />
          <div>
            <h2 className="font-heading uppercase text-3xl sm:text-4xl tracking-tighter leading-tight">
              Rated <span className="text-orange">4.8</span> across Zomato, Swiggy & Google
            </h2>
            <p className="text-cream/70 mt-3">
              Consistency is our flex. Whether you dine in or order at midnight, the kukkad shows up right — every single time.
            </p>
          </div>
        </Reveal>
      </section>

      {/* Masonry-ish grid */}
      <section className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 [column-fill:_balance]" data-testid="reviews-grid">
          {data.testimonials.map((t, i) => (
            <Reveal key={t.id} delay={(i % 3) * 0.08} className="break-inside-avoid mb-6">
              <div data-testid={`review-${t.id}`} className="bg-card border border-border rounded-lg p-6 hover:border-orange transition-colors">
                <Quote className="w-8 h-8 text-orange/40" />
                <p className="text-cream/90 text-lg mt-3 leading-relaxed">&ldquo;{t.text}&rdquo;</p>
                <div className="flex items-center justify-between mt-5 pt-4 border-t border-border">
                  <div>
                    <p className="font-heading uppercase text-lg tracking-tight">{t.name}</p>
                    <p className="text-cream/50 text-sm">{t.role}</p>
                  </div>
                  <Stars rating={t.rating} />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
